import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { finalize, catchError } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { AccounDataDTO, BranchDTO, CustomerDTO, CustomerService, LookUpService } from 'synergy-core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.sass']
})
export class CustomerComponent implements OnInit {
  cols!: any[];
  personTypes!: any[];
  countries!: any[];
  states!: any[];
  cities!: any[];
  districts!: any[];
  nighboorhoods!: any[];
  data!: BranchDTO[];
  filteredData!: any[];
  selectedId!: string;
  submitted: boolean = false;
  loading: boolean = false;
  showDialog: boolean = false;
  controlDisabled: string = "disabled";
  buttonDisabled!: boolean;
  entityName: string = "Clientes"
  entityDescription: string = "Mantemiento de clientes"
  masterForm!: FormGroup;
  organizationSubmitted: boolean = false;
  currentUser!: AccounDataDTO;



  

  constructor(
    private customerService: CustomerService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private lookupDataService: LookUpService,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    this.getPersonTypes();
    this.getCountries();
    this.getData();
    this.setForm();
    this.setDetail();
  }

  getPersonTypes() {
    this.lookupDataService.getPersonTypes().subscribe(data => {
      if (data) {
        this.personTypes = data;
      }
    });
  }


  setForm() {
    this.masterForm = new FormGroup({
      id: new FormControl('00000000-0000-0000-0000-000000000000',),
      name: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
      lastName: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
      email: new FormControl(null, [Validators.required, Validators.email]),
      phoneNumber1: new FormControl("(506)", [Validators.required]),
      phoneNumber2: new FormControl("(506)"),
      countryId: new FormControl(null, [Validators.required]),
      stateId: new FormControl(null, [Validators.required]),
      cityId: new FormControl(null, [Validators.required]),
      districtId: new FormControl(null, [Validators.required]),
      neighborhoodId: new FormControl(null),
      identification: new FormControl(null, [Validators.required]),
      personTypeId: new FormControl(null, [Validators.required]),
      address: new FormControl(null, [Validators.required, Validators.maxLength(500)]),
      detail: new FormControl(null, [Validators.maxLength(500)]),
      isActive: new FormControl(true),
    });

    this.masterForm.disable();
  }

  setDetail() {
    this.cols = [
      { field: 'Id', header: 'Id' },
      { field: 'Name', header: 'Nombre' },
      { field: 'Detail', header: 'Detalle' },
    ];
  }

  getCountries() {
    this.lookupDataService.GetCountries().subscribe(val => {
      this.countries = val.Data;
    });
  }

  getData() {
    const httpParams = new HttpParams().set('clientId', this.currentUser.ClientId);
    this.customerService.Get(httpParams).subscribe(val => {
      this.data = val.Data;
    });
  }

  getById(id: string) {
    const httpParams = new HttpParams().set('clientId', this.currentUser.ClientId)
      .set('id', id);

    this.customerService.GetById(httpParams).subscribe(val => {
      let customer = val.Data[0];
      setTimeout(() => {
        this.onSelectCountry(customer.CountryId);
      }, 50);
      setTimeout(() => {
        this.onSelectState(customer.StateId);
      }, 50);
      setTimeout(() => {
        this.onSelectCity(customer.CityId);
      }, 50);
      setTimeout(() => {
        this.onSelectDistrict(customer.DistrictId);
      }, 50);


      setTimeout(() => {
        this.masterForm.controls["countryId"].setValue(customer.CountryId);
        this.masterForm.controls["stateId"].setValue(customer.StateId);
        this.masterForm.controls["cityId"].setValue(customer.CityId);
        this.masterForm.controls["districtId"].setValue(customer.DistrictId);
        this.masterForm.controls["neighborhoodId"].setValue(customer.NeighborhoodId);
        this.masterForm.controls["id"].setValue(customer.Id);
        this.masterForm.controls["name"].setValue(customer.Name);
        this.masterForm.controls["email"].setValue(customer.EmailAddress);
        this.masterForm.controls["lastName"].setValue(customer.LastName);
        this.masterForm.controls["personTypeId"].setValue(customer.PersonTypeId);
        this.masterForm.controls["identification"].setValue(customer.Identification);
        this.masterForm.controls["phoneNumber1"].setValue(customer.PhoneNumber1);
        this.masterForm.controls["phoneNumber2"].setValue(customer.PhoneNumber2);
        this.masterForm.controls["address"].setValue(customer.Address);
        this.masterForm.controls["detail"].setValue(customer.Detail);
        this.masterForm.controls["isActive"].setValue(customer.IsActive);
      }, 50);
    });
  }

  onSelectCountry(id: number) {
    this.lookupDataService.GetStatesByCountryId(id).subscribe(data => {
      if (data) {
        this.states = data.Data;
      }
    });
  }

  onSelectState(id: number) {
    this.lookupDataService.GetCityByStateId(id).subscribe(data => {
      if (data) {
        this.cities = data.Data;
      }
    });
  }

  onSelectCity(id: number) {
    this.lookupDataService.GetDistrictByCityId(id).subscribe(data => {
      if (data) {
        this.districts = data.Data;
      }
    });
  }

  onSelectDistrict(id: number) {
    this.lookupDataService.GetNeighborhoodByDistrictId(id).subscribe(data => {
      if (data) {
        this.nighboorhoods = data.Data;
      }
    });
  }

  onAddNew() {
    this.masterForm.enable();
    this.buttonDisabled = true;
    this.masterForm.reset({ id: '00000000-0000-0000-0000-000000000000', phoneNumber1: "(506)", phoneNumber2: "(506)", isActive: true });
  }

  onSubmit() {
    this.submitted = true;

    if (this.masterForm.invalid) {
      return;
    }

    this.loading = true;
    let dto = new CustomerDTO();

    dto.ClientId = this.currentUser.ClientId;
    dto.Id = this.masterForm.value.id;
    dto.ApplicationId = environment.applicayionId;
    dto.Name = this.masterForm.value.name;
    dto.LastName = this.masterForm.value.lastName;
    dto.EmailAddress = this.masterForm.value.email;
    dto.PhoneNumber1 = this.masterForm.value.phoneNumber1;
    dto.PhoneNumber2 = this.masterForm.value.phoneNumber2;
    dto.CountryId = this.masterForm.value.countryId;
    dto.StateId = this.masterForm.value.stateId;
    dto.CityId = this.masterForm.value.cityId;
    dto.DistrictId = this.masterForm.value.districtId;
    dto.NeighborhoodId = this.masterForm.value.neighborhoodId;
    dto.Address = this.masterForm.value.address;
    dto.Detail = this.masterForm.value.detail;
    dto.IsActive = this.masterForm.value.isActive;
    dto.PersonTypeId = this.masterForm.value.personTypeId;
    dto.Identification = this.masterForm.value.identification;
    dto.CreatedBy = this.currentUser.Id;
    dto.CreatedDate = new Date();
    dto.ModifiedBy = this.currentUser.Id;
    dto.ModifiedDate = new Date();
    if (this.masterForm.value.id == '00000000-0000-0000-0000-000000000000') {
      this.customerService.Create(dto).pipe(
        finalize(() => {
          this.loading = false;
          this.submitted = false;
          this.controlDisabled = "disabled";
          this.buttonDisabled = false;
        }),
        catchError((error) => {
          throw error;
        })).subscribe((data) => {
          if (data.Success) {
            this.messageService.add({ key: 'tc', severity: 'info', summary: 'Proceso completado exitosamente', detail: 'Se ha creado el nuevo cliente.' });
            this.masterForm.reset({ phoneNumber1: "(506)", phoneNumber2: "(506)", isActive: true });
            this.getData();
          } else {
            this.messageService.add({ key: 'tc', severity: 'error', summary: "Se ha producido un error", detail: data.Message });
          }
        });
    } else {
      this.customerService.Update(dto).pipe(
        finalize(() => {
          this.loading = false;
          this.submitted = false;
        }),
        catchError((error) => {
          throw error;
        })).subscribe((data) => {
          if (data.Success) {
            this.messageService.add({ key: 'tc', severity: 'info', summary: 'Proceso completado exitosamente', detail: 'Se ha actualizado el cliente.' });
            this.masterForm.reset({ phoneNumber1: "(506)", phoneNumber2: "(506)", isActive: true });
            this.masterForm.disable();
            this.buttonDisabled = false;
            this.getData();
          } else {
            this.messageService.add({ key: 'tc', severity: 'error', summary: "Se ha producido un error", detail: data.Message });
          }
        });
    }
  }

  onEdit() {
    if (this.selectedId != '') {
      this.masterForm.enable();
      this.buttonDisabled = true;
    }
  }

  onDelete() {
    this.confirmationService.confirm({
      message: 'Desea realmente eliminar el registro?',
      header: 'Confirmacion',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.loading = true;
        const httpParams = new HttpParams().set('clientId', this.currentUser.ClientId)
          .set('id', this.masterForm.value.id.toString())
          .set('userId', this.currentUser.Id);
        this.customerService.Delete(httpParams).pipe(
          finalize(() => {
            this.loading = false;
          }),
          catchError((error) => {
            throw error;
          })).subscribe((data) => {
            if (data.Success) {
              this.messageService.add({ key: 'tc', severity: 'info', summary: 'Proceso completado exitosamente', detail: 'Se ha eliminado el cliente.' });
              this.masterForm.reset();
              this.masterForm.disable();
              this.buttonDisabled = false;
              this.getData();
            } else {
              this.messageService.add({ key: 'tc', severity: 'error', summary: "Se ha producido un error", detail: data.Message });
            }
          });
      },
      reject: () => {
      }
    });
  }

  onShowDialog() {
    this.showDialog = true;
  }

  onSelectFromGrid() {
    this.showDialog = false;
    this.getById(this.selectedId);
  }

  onCancel() {
    this.masterForm.disable();
    this.buttonDisabled = false;
  }

  onFilter(event: any) {
    let query = event.query;
    this.filteredData = this.filterData(query);
  }

  onSelect(event: any) {
    this.getById(event.Id);
  }

  filterData(query: any): any[] {
    let filtered: any[] = [];
    for (let i = 0; i < this.data.length; i++) {
      let current = this.data[i];
      if (current.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(current);
      }
    }
    return filtered;
  }

  get masterControls() {
    return this.masterForm.controls;
  }
}

